import { Directive, ElementRef, EventEmitter, Input, NgZone, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ApiCollection } from '../../api/collection';

@Directive({
    selector: '[chassisDragDrop]'
})
export class DragDropDirective implements OnInit, OnChanges {

    @Input() chassisDragDrop;
    @Input() draggable;
    @Input() droppable;
    @Input() sortable;
    @Input() options: Object = {};
    @Input() orderKey: string;

    @Output() start: EventEmitter<any>      = new EventEmitter();
    @Output() activate: EventEmitter<any>   = new EventEmitter();
    @Output() deactivate: EventEmitter<any> = new EventEmitter();
    @Output() update: EventEmitter<any>     = new EventEmitter();
    @Output() dropped: EventEmitter<any>    = new EventEmitter();
    @Output() removed: EventEmitter<any>    = new EventEmitter();
    @Output() created: EventEmitter<any>    = new EventEmitter();

    public collection;
    public singleItem;
    public settings = {};

    constructor(private el: ElementRef, private zone: NgZone) {
    }

    public ngOnInit() {

        const type = this.sortable !== undefined ? 'sortable' : (this.draggable !== undefined ? 'draggable' : 'droppable');

        this.settings = $.extend(true, {
            placeholder: 'chassis-drag-drop-placeholder',
            forcePlaceholderSize: true,

            cancel: '',
            start: (e, ui) => {

                // const height = ui.item.innerHeight();
                // $('> td', ui.placeholder).css('height', height);

                this.start.emit(e);
            },
            update: (e, ui) => {

                // console.warn('update', ui.item, ui.item.data('drag-drop-item'));
                this.updateOrder(ui.item, ui);

            },
            create: (e, ui) => {

                this.created.emit();

            },
            activate: () => {
                this.activate.emit();
            },
            deactivate: () => {
                this.deactivate.emit();
            }
        }, this.getTypeOptions(type), this.options);

        (<any>$(this.el.nativeElement))[type](this.settings);

    }

    /**
     * Change of input
     *
     * @param changes
     */
    public ngOnChanges(changes: SimpleChanges) {

        if (changes['chassisDragDrop'] && changes['chassisDragDrop'].currentValue) {

            // for sortables -> treat input as collection
            if (this.sortable !== undefined) {
                this.collection = changes['chassisDragDrop'].currentValue;

                this.attachDataToElements();

                // console.log('first dom element data', $(this.el.nativeElement).first());

            } else { // for draggables -> treat input as single item

                this.singleItem = changes['chassisDragDrop'].currentValue;

                this.attachDataToElement();
            }

        }
    }

    /**
     * Get drag and drop DOM elements
     *
     * @returns {Promise<T>|Promise}
     */
    protected getDragDropElements() {

        return new Promise((resolve) => {

            // set a timeout for rendering the ngFor list
            setTimeout(() => {
                resolve($(this.settings['items'], this.el.nativeElement));
            }, 100);

        });
    }

    /**
     * Attach data to single item
     */
    protected attachDataToElement() {
        $(this.el.nativeElement).data('drag-drop-item', this.singleItem);
    }

    /**
     * Attach data from collection to DOM elements
     *
     */
    protected attachDataToElements() {

        this.getDragDropElements().then(elements => {

            let i = 0;

            // console.warn('start attaching data', $(this.el.nativeElement).children());

            for (const item of this.getCollection()) {
                // console.log('attach data to item', item, $(elements[i]));
                $(elements[i]).data('drag-drop-item', item);

                // set order
                if (this.orderKey) {
                    item[this.orderKey] = i;
                }

                i++;
            }

        });

    }

    /**
     * Update collection order
     *
     * @param updatedItem
     */
    protected updateOrder(updatedItem, ui) {

        this.zone.run(() => {

            const sameRow          = $(this.el.nativeElement).find(updatedItem).length > 0;
            const updatedItemData  = updatedItem.data('drag-drop-item');
            const updatedItemIndex = this.options['items'] ? updatedItem.index(this.options['items']) : updatedItem.index();

            console.log('update order', this.orderKey, updatedItemData, sameRow);

            if (this.orderKey && updatedItemData && sameRow) {

                // remove updatedItem
                this.getCollection().splice(updatedItemData[this.orderKey], 1);

                // re-insert at new position
                this.getCollection().splice(updatedItemIndex, 0, updatedItemData);

                // recalculate order
                let i = 0;
                for (const item of this.getCollection()) {
                    item[this.orderKey] = i;
                    i++;
                }

                console.log('new collection after sort', this.getCollection());

                // emit update event
                this.update.emit();
            }

        });

    }

    protected receiveItem(receivedItem) {

        this.dropped.emit({
            data: receivedItem.data('drag-drop-item'),
            item: receivedItem,
            index: receivedItem.index()
        });

    }

    protected removeItem(removedItem) {

        this.removed.emit({
            data: removedItem.data('drag-drop-item'),
            item: removedItem,
            index: removedItem.index()
        });

    }

    /**
     * Returns the collection
     *
     * @returns {any}
     */
    protected getCollection() {
        return this.collection instanceof ApiCollection ? this.collection.all() : this.collection;
    }

    protected getTypeOptions(type) {

        if (type === 'sortable') {

            return {
                items: '> *',
                remove: (e, ui) => {
                    this.removeItem(ui.item);
                },
                receive: (e, ui) => {
                    this.receiveItem(ui.item);
                },
                sort: () => {
                    // console.warn('sort item');
                },
                change: () => {
                    // console.warn('sort item');
                }
            };

        } else if (type === 'draggable') {

            return {
                refreshPositions: true
            };

        } else if (type === 'droppable') {

            return {
                drop: (event, ui) => {
                    const draggable = $(ui.draggable[0]).data('drag-drop-item');

                    this.dropped.emit({
                        event: event,
                        ui: ui,
                        draggable: draggable,
                        droppable: this.singleItem
                    });
                }
            };

        }

    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/support/directives/drag-drop.directive.ts